import styled from "styled-components";

export const StyledWrapper = styled.form`
  width: 100%;
  // max-width: 1000px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: auto;
  visibility: ${({ showform }) => (showform ? "visible" : "hidden")};
  transition: max-height 0.5s;

  ${({ theme }) => theme.media.onlyMobile`
    width: ${({ intentlevel }) => `calc(100% - 5% * ${intentlevel})`};
  `}

  > div:first-child {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;

    ${({ theme }) => theme.media.onlyMobile`
      flex-direction: column;
    `}
  }

  > div:last-child {
    margin-top: 18px;
    padding-bottom: 40px;

    > button {
      height: 32px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: ${({ theme }) => theme.colors.neutralsWhite};
      background: ${({ theme }) => theme.colors.primaryBackground};
      border: none;
      border-radius: 4px;
      padding: 0 12px;
      cursor: pointer;
    }
  }
`;

export const StyledTextAreaWrapper = styled.div`
  position: relative;
  width: ${({ intentlevel }) => `calc(75% - 128px * ${intentlevel})`};

  ${({ theme }) => theme.media.onlyMobile`
    width: calc(100% - 30px);
    align-self: flex-end;
  `}

  > span {
    position: absolute;
    top: 6px;
    left: 8px;
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    ${({ theme }) => theme.fontStyles.InterfaceCopy}
  }

  > div {
    position: absolute;
    bottom: 21px;
    right: 8px;
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    ${({ theme }) => theme.fontStyles.InterfaceCopy}

    > span {
      color: ${({ theme }) => theme.colors.primaryText};
      font-weight: 600;
    }
  }

  > textarea {
    width: 100%;
    height: 165px;
    resize: none;
    border: none;
    border-bottom: 2px solid #a199c2;
    padding: 26px 8px 36px 8px;
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    ${({ theme }) => theme.fontStyles.CommentsBody}

    &:focus {
      box-shadow: unset;
      border-color: unset;
    }

    &::placeholder {
      color: ${({ theme }) => theme.colors.neutralsTextDisabled};
      ${({ theme }) => theme.fontStyles.InterfaceCopySmall}
      font-size: 14px;
      line-height: 20px;
    }
  }
`;
